import { useMutation, useQuery, useQueryClient } from '@tanstack/react-query'
import { http } from './client'
import { invalidateLibrary } from './entries'
import type { Tag, TagCreate } from './types'

export function useTags() {
  return useQuery({
    queryKey: ['tags'],
    queryFn: async ({ signal }) => {
      const { data } = await http.get<Tag[]>('/api/tags', { signal })
      return data
    },
  })
}

export function useCreateTag() {
  const qc = useQueryClient()
  return useMutation({
    mutationFn: async (body: TagCreate) => {
      const { data } = await http.post<Tag>('/api/tags', body)
      return data
    },
    onSuccess: () => qc.invalidateQueries({ queryKey: ['tags'] }),
  })
}

export function useUpdateTag() {
  const qc = useQueryClient()
  return useMutation({
    mutationFn: async ({ id, body }: { id: number; body: Partial<TagCreate> }) => {
      const { data } = await http.patch<Tag>(`/api/tags/${id}`, body)
      return data
    },
    onSuccess: () => {
      invalidateLibrary(qc, { tags: true, links: true, entries: true })
    },
  })
}

export function useDeleteTag() {
  const qc = useQueryClient()
  return useMutation({
    mutationFn: async (id: number) => {
      await http.delete(`/api/tags/${id}`)
    },
    onSuccess: () => {
      invalidateLibrary(qc, { tags: true, links: true, entries: true })
    },
  })
}
